module.exports = __webpack_public_path__ + "img/3.c6a3f57e.svg";